import {
	ADD_HOTEL_FROM_AIRBNB_URL_MUTATION,
	ADD_HOTEL_FROM_BOOKING_URL_MUTATION,
	FIND_HOTEL_QUERY,
	FIND_HOTEL_SUGGESTIONS_MUTATION,
} from '@app/model/hotel/service/HotelGraphQLQueries';
import Hotel from '@app/model/hotel/Hotel';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import { HotelSuggestionsOutput } from '@app/model/hotel/HotelSuggestionsOutput';


class HotelService {
    public static findHotelById(id: number) {
        return GraphQLExecutor.execute<Hotel>(FIND_HOTEL_QUERY, {id})
    }

    public static addHotelFromBookingUrl(url: string) {
        return GraphQLExecutor.execute<Hotel>(ADD_HOTEL_FROM_BOOKING_URL_MUTATION, {url})
    }

    public static addHotelFromAirbnbUrl(url: string) {
        return GraphQLExecutor.execute<Hotel>(ADD_HOTEL_FROM_AIRBNB_URL_MUTATION, {url})
    }

    public static findHotelSuggestions(hotelId: number) {
        return GraphQLExecutor.execute<HotelSuggestionsOutput>(FIND_HOTEL_SUGGESTIONS_MUTATION, {hotelId})

    }
}

export default HotelService;
